import React, { useState } from 'react';
import { Button, Col, Form, FormGroup, Input, InputGroup, Label, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

import Body from '../Components/layout/Body';
import { USERS, USERS_STEPS } from './ConstPaths';

const LOGIN_HELP = `
<div>
  <p>If you've already set up an account in Access Navigator, just enter your username and password to login.</p>
  <p>To stay logged in, check 'Remember me.' This will login to your account automatically the next time you run Access Nav.</p>
  <p>'Forgot password?' allows you to receive a password reset link via email. Enter your username, then click 'Forgot password?' <strong>Note:</strong> This only works if you have entered an email address for your account.</p>
  <p>Why login? You must be logged in to save data. That allows you to do things like resume a session without losing your work, or review previous sessions with a client. 
  (If you aren't logged in, the data is available in the browser tab but will be erased when you refresh the tab or restart your browser.)</p>
  <p>Why a username? To allow you to protect your information, we do not require an email address for accounts. If you included an email address in your account info, you 
  can use that instead of a username for logging in, if you prefer.  (You are also free to enter your email address as your username when creating your account -- we just
  did not want to require you to do that.)</p>  
</div>
`;

//content sub-component with unique content for this page
function UsersLoginContent(props) {
  const {
    username,
    password,
    onChangeUsername,
    onChangePassword,
    userStatus,
    stayLoggedIn,
    onChangeStayLoggedIn,
    onResetPassword,
    onContinue
  } = props;

  const [isPwdHidden, setIsPwdHidden] = useState(true);

  // const togglePassword = () => {
  //   const passwordInput = document.getElementById('password');
  //   if (passwordInput.type === 'password') {
  //     passwordInput.type = 'text';
  //   } else {
  //     passwordInput.type = 'password';
  //   }
  // };

  const togglePwd = () => {
    setIsPwdHidden(!isPwdHidden);
  }

  const handlePasswordKeyPress = (event) => {
    if (event.key === 'Enter' && username.trim() !== '') {
      onContinue();
    }
  };

  /* invalid property turns the field border red when value is invalid.
    For username, this occurs when field is empty or the specified user does not exist (per UsersTab.checkLogin).
    For password, this occurs when user exists but password is incorrect.
    required property doesn't have any visual behavior -- it may announce required to screen readers
  */

  return(
    <>
    <Row>
      <Col>
        <Form>
          <FormGroup>
            <Label for="username" className="aa-bold-text">
              Username <span className="aa-field-required">*</span>
            </Label>
            <Input
              id="username"
              value={username}
              onChange={onChangeUsername}
              name="username"
              type="textfield"
              invalid={userStatus === 0}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="password" className='aa-bold-text'>
              Password <span className="aa-field-required">*</span>
            </Label>
            <InputGroup>
              <Input
                id="password"
                value={password}
                onChange={onChangePassword}
                onKeyDown={handlePasswordKeyPress}
                name="password"
                type={isPwdHidden ? "password" : "text"}
                invalid={userStatus === 1}
                required
              />
              <Button outline className="aa-btn-within-field" onClick={togglePwd}
                ><span className={isPwdHidden ? 'fa fa-eye' : 'fa fa-eye-slash'}></span>
              </Button>
            </InputGroup>
            <Row>
              <Col>
                <Button color="link" onClick={onResetPassword}>
                  Forgot password?
                </Button>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup check>
            <Input
              id="stay-logged-in"
              type="checkbox"
              checked={stayLoggedIn}
              onChange={onChangeStayLoggedIn}
            />
            {' '}
            <Label for="stay-logged-in" check>
              Remember me
            </Label>
          </FormGroup>
          <FormGroup>
            <Row className="aa-review-row">
              <Col>
                <Button color="primary" onClick={onContinue}>Login</Button>
              </Col>
            </Row>
          </FormGroup>
        </Form>
        <hr />
        <Row>
          <Col>
            <p>Don't have an account?&nbsp;
            <Link className="btn-link" to={USERS + "/" + USERS_STEPS.CREATE}>Sign up now</Link></p>
          </Col>
        </Row>
      </Col>
      {/* puts a little margin on the right, for large screen sizes */}
      {/* <div className="col-lg-4"></div> */}
      <Col lg="4"></Col>
    </Row>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function UsersLogin(props) {
  const {
    username,
    onChangeUsername,
    password,
    onChangePassword,
    userStatus,
    stayLoggedIn,
    onChangeStayLoggedIn,
    onResetPassword,
    onContinue
  } = props;

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used, but could supply an image on page
    faIcon: "fa-users aa-fa-3x", //include this font-awesome icon in the image column of the page
    title: "Login",
    subTitle: "Login to your existing practitioner account",
    learnMore: {linkText: "Learn More about the login process",
                title: "Logging In",
                content: LOGIN_HELP
                },
    nextRoute: '', //EVAL_INTRO, //static name for next page since this never changes
    sidebar: false
  }

  console.log("rendering UsersLogin, props:" + JSON.stringify(props));

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <UsersLoginContent 
          username={username}
          onChangeUsername={onChangeUsername}
          password={password}
          onChangePassword={onChangePassword}
          userStatus={userStatus}
          stayLoggedIn={stayLoggedIn}
          onChangeStayLoggedIn={onChangeStayLoggedIn}
          onResetPassword={onResetPassword}
          onContinue={onContinue}
        />
      } 
      onContinue={onContinue}
    />
    </>
  );
}

export default UsersLogin;